import { render, staticRenderFns } from "./TabbedPortletHead.vue?vue&type=template&id=987754ce&scoped=true&"
import script from "./TabbedPortletHead.vue?vue&type=script&lang=js&"
export * from "./TabbedPortletHead.vue?vue&type=script&lang=js&"
import style0 from "./TabbedPortletHead.vue?vue&type=style&index=0&id=987754ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987754ce",
  null
  
)

export default component.exports